export default async function createTemplate({ commit, rootGetters, dispatch }, templateData) {
    try {
        commit('SET_CREATE_TEMPLATE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const data = {
            ...templateData,
            customer_id
        };

        const response = await window.axios.post('/proxy/ai/extract-templates', data);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Extract template created successfully', { root: true });
            return response.data.data;
        } else {
            dispatch('notifications/setError', 'Failed to create extract template', { root: true });
        }
    } catch (error) {
        console.error('Error creating extract template:', error);
        dispatch('notifications/setError', 'Failed to create extract template', { root: true });
    } finally {
        commit('SET_CREATE_TEMPLATE_LOADING', false);
    }
}